import React, { lazy } from 'react';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-16 md:py-24 bg-rose-50 border-t border-rose-100" data-id="element-156">
      <div className="container mx-auto px-4 md:px-6" data-id="element-157">
        <div className="max-w-4xl mx-auto bg-white rounded-3xl p-8 md:p-12 shadow-xl flex flex-col md:flex-row items-center gap-8 md:gap-12" data-id="element-158">
          <div className="shrink-0 relative" data-id="element-159">
            <div className="w-40 h-40 rounded-full bg-gradient-to-br from-amber-100 to-amber-50 flex items-center justify-center border-4 border-amber-200 shadow-inner" data-id="element-160">
              <ShieldCheck className="w-20 h-20 text-amber-500" data-id="element-161" />
            </div>
            <div className="absolute -bottom-4 left-1/2 -translate-x-1/2 bg-amber-500 text-white text-xs font-bold px-3 py-1 rounded-full shadow-md whitespace-nowrap" data-id="element-162">
              100% RISK FREE
            </div>
          </div>

          <div className="text-center md:text-left" data-id="element-163">
            <h2 className="text-3xl font-bold text-gray-900 mb-4 font-serif" data-id="element-164">
              90-Day Smile Guarantee
            </h2>
            <p className="text-xl text-gray-700 mb-3 leading-relaxed" data-id="element-165">
              Try Dentafix™ for 90 days.
            </p>
            <p className="text-lg text-gray-600 mb-3 leading-relaxed" data-id="element-166">
              If you don't feel secure, confident, and comfortable…
            </p>
            <p className="text-xl font-bold text-gray-900 mb-6" data-id="element-167">
              We refund you. No forms. No stress. No questions.
            </p>
            <p className="text-sm text-gray-500 font-medium" data-id="element-168">
              Trusted by 50,000+ customers worldwide
            </p>
          </div>
        </div>

        <div className="max-w-4xl mx-auto mt-12 grid grid-cols-3 gap-4" data-id="element-169">
          <img src="https://images.unsplash.com/photo-1581579438747-104c53d7fbc4?w=400&q=80" alt="Happy senior woman smiling" className="rounded-xl h-40 w-full object-cover shadow-md" loading="lazy" data-id="element-170" />
          <img src="https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?w=400&q=80" alt="Trusted by medical professionals" className="rounded-xl h-40 w-full object-cover shadow-md" loading="lazy" data-id="element-171" />
          <img src="https://images.unsplash.com/photo-1574279606130-09958dc756f7?w=400&q=80" alt="Senior enjoying life confidently" className="rounded-xl h-40 w-full object-cover shadow-md" loading="lazy" data-id="element-172" />
        </div>
      </div>
    </section>;
}